import { useQuery } from '@tanstack/react-query';
import { api } from './api';

export interface WaThread {
  id: string; phone: string; contactName: string | null; lastMessageAt: string; lastPreview: string | null; unreadCount: number;
  lastInboundAt: string | null; optedOut: boolean; assignedTo: string | null; assignedName: string | null;
  leadId: string | null; leadNumber: number | null; leadName: string | null;
}
export interface WaMessage {
  id: string; direction: 'in' | 'out'; type: string; body: string | null; status: string; error: string | null;
  templateName: string | null; mediaMeta: { mime?: string; filename?: string | null } | null; mediaUrl: string | null; createdAt: string; sentByName: string | null; sentByAi?: boolean;
}
export interface WaTemplate { name: string; language: string; category: string | null; status: string; bodyText: string | null; paramCount: number }
export interface WaSettingsView {
  connected: boolean; displayPhone: string; verifiedName: string; phoneNumberId: string; wabaId: string; autoCreateLeads: boolean;
  tokenHint: string | null; webhookUrl: string | null; verifyToken: string | null;
}

export const useWaSettings = () => useQuery({ queryKey: ['whatsapp', 'settings'], queryFn: () => api.get<WaSettingsView>('/whatsapp/settings'), staleTime: 60_000 });
export const useWaTemplates = () => useQuery({ queryKey: ['whatsapp', 'templates'], queryFn: () => api.get<WaTemplate[]>('/whatsapp/templates'), staleTime: 60_000 });

export const windowOpen = (lastInboundAt: string | null) => !!lastInboundAt && Date.now() - new Date(lastInboundAt).getTime() < 24 * 3600_000;

/** Hours left to reply freely, e.g. "21h left". */
export function windowLeft(lastInboundAt: string | null): string | null {
  if (!windowOpen(lastInboundAt)) return null;
  const ms = 24 * 3600_000 - (Date.now() - new Date(lastInboundAt!).getTime());
  const h = Math.floor(ms / 3600_000);
  return h >= 1 ? `${h}h left to reply` : `${Math.max(1, Math.floor(ms / 60_000))} min left to reply`;
}

export const renderTemplate = (body: string | null, params: string[]) =>
  (body ?? '').replace(/\{\{(\d+)\}\}/g, (_, n) => params[Number(n) - 1] || `{{${n}}}`);
